import { supabase } from '@/lib/supabase'

export type RevshareParticipant = {
  user_id: string
  share_bps: number
  status: 'active' | 'suspended' | 'removed' | string
  active_from: string
  inactive_at: string | null
  full_name?: string | null
  email?: string | null
}

export async function listRevshareParticipants(): Promise<RevshareParticipant[]> {
  const { data, error } = await supabase
    .from('revshare_participants')
    .select('user_id, share_bps, status, active_from, inactive_at')
    .order('status', { ascending: true })
    .order('share_bps', { ascending: false })
  if (error) throw error

  const base = ((data as any) || []) as RevshareParticipant[]
  const ids = Array.from(new Set(base.map((p) => p.user_id).filter(Boolean)))
  if (ids.length === 0) return base

  const { data: profs } = await supabase
    .from('v_profiles_contact_master')
    .select('id, full_name, email')
    .in('id', ids)
  const byId = new Map((profs || []).map((p: any) => [p.id, p]))
  return base.map((p) => {
    const prof = byId.get(p.user_id)
    return {
      ...p,
      full_name: prof?.full_name ?? null,
      email: prof?.email ?? null,
    }
  })
}

export type UpsertRevshareParticipantInput = {
  user_id?: string
  email?: string
  share_bps?: number
  share_percent?: number
  status?: 'active' | 'suspended' | 'removed'
}

export async function upsertRevshareParticipant(input: UpsertRevshareParticipantInput) {
  const { data, error } = await supabase.functions.invoke('admin-revshare-upsert-participant', { body: input })
  if (error) throw error
  return data as any
}

export type RebalanceRevshareSharesInput = {
  shares: Array<{ user_id: string; share_bps?: number; share_percent?: number }>
}

export async function rebalanceRevshareShares(input: RebalanceRevshareSharesInput) {
  const { data, error } = await supabase.functions.invoke('admin-revshare-rebalance-shares', { body: input })
  if (error) throw error
  return data as any
}

